import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('@/locales/json', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// export default new VueI18n({
//   locale: Cookies.get('locale') ?? 'mm',
//   locale: 'mm',
//   fallbackLocale: 'mm',
//   messages: loadLocaleMessages(),
// })

// Get saved locale or default to 'en'
const savedLocale = Cookies.get('locale') || 'en'
Cookies.set('locale', 'en', { expires: 365 })

export default new VueI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: loadLocaleMessages(),
})
